import { useState, useEffect } from 'react';
import api from '../../lib/api';

interface Badge {
  id: string;
  badgeType: string;
  title: string;
  description: string;
  icon: string;
  rarity: string;
  earnedAt: string;
}

const RARITY_COLORS: Record<string, string> = {
  common: 'bg-slate-100 border-slate-200',
  rare: 'bg-blue-50 border-blue-200',
  epic: 'bg-purple-50 border-purple-200',
  legendary: 'bg-amber-50 border-amber-200 ring-1 ring-amber-300',
};

const RARITY_LABELS: Record<string, string> = {
  common: 'Common',
  rare: 'Rare',
  epic: 'Epic',
  legendary: 'Legendary',
};

export default function BadgesCard() {
  const [badges, setBadges] = useState<Badge[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBadges();
  }, []);

  const loadBadges = async () => {
    try {
      const res = await api.get('/api/mundus/badges/all');
      setBadges(res.data.badges || []);
    } catch {
      // No badges
    } finally {
      setLoading(false);
    }
  };

  if (loading) return null;
  if (badges.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4">
      <h3 className="text-sm font-semibold text-slate-900 mb-3">Badges</h3>
      <div className="flex flex-wrap gap-2">
        {badges.map((badge) => (
          <div
            key={badge.id}
            title={`${badge.title}: ${badge.description}`}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border text-xs font-medium ${
              RARITY_COLORS[badge.rarity] || RARITY_COLORS.common
            }`}
          >
            <span className="text-base">{badge.icon}</span>
            <span className="text-slate-700">{badge.title}</span>
            <span className="text-[10px] text-slate-400">
              {RARITY_LABELS[badge.rarity] || ''}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
